module.exports = __webpack_public_path__ + "img/home-5.5debc737.webp";